import React from 'react';
import { Link } from 'react-router-dom';

const baseClasses = "transition-colors duration-200";
const variantClasses = {
  primary: "text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300",
  danger: "text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300",
  secondary: "text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-300"
};

export const ActionButton = ({ action, item }) => {
  if (action.type === 'link') {
    return (
      <Link
        to={typeof action.to === 'function' ? action.to(item) : action.to}
        className={`${baseClasses} ${variantClasses[action.variant || 'primary']}`}
      >
        {action.label}
      </Link>
    );
  }

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        action.onClick(item);
      }}
      className={`${baseClasses} ${variantClasses[action.variant || 'primary']}`}
    >
      {action.label}
    </button>
  );
};

export const MobileActionButton = ({ action, item }) => {
  const baseClasses = "flex-1 px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200";
  const mobileVariantClasses = {
    primary: "text-indigo-600 dark:text-indigo-400 bg-indigo-50 dark:bg-indigo-900/20 hover:bg-indigo-100 dark:hover:bg-indigo-900/40",
    danger: "text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20 hover:bg-red-100 dark:hover:bg-red-900/40",
    secondary: "text-gray-600 dark:text-gray-400 bg-gray-50 dark:bg-gray-900/20 hover:bg-gray-100 dark:hover:bg-gray-900/40"
  };

  if (action.type === 'link') {
    return (
      <Link
        to={typeof action.to === 'function' ? action.to(item) : action.to}
        className={`${baseClasses} ${mobileVariantClasses[action.variant || 'primary']} text-center`}
      >
        {action.label}
      </Link>
    );
  }

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        action.onClick(item);
      }}
      className={`${baseClasses} ${mobileVariantClasses[action.variant || 'primary']}`}
    >
      {action.label}
    </button>
  );
};